import * as React from 'react';
import './index.css';
import PlateHead from './PlateHead';
import PlateBuyer from './PlateBuyer';
import { PlateGoods, PlateGoodsVirtualized } from './PlateGoods';
import PlateSeller from './PlateSeller';
import PlatePerson from './PlatePerson';
export default function Plate(props) {
    var buyerData = props.buyerData, sellerData = props.sellerData, goodsColumns = props.goodsColumns, goodsData = props.goodsData, totalNum = props.totalNum, totalNumText = props.totalNumText, invoiceData = props.invoiceData, invoiceDataColumns = props.invoiceDataColumns, personData = props.personData, otherElement = props.otherElement, goodsOption = props.goodsOption, isVirtualized = props.isVirtualized, buyerTitle = props.buyerTitle, sellerTitle = props.sellerTitle;
    return (React.createElement("div", { className: 'plate_box' },
        React.createElement(PlateHead, { invoiceData: invoiceData, invoiceDataColumns: invoiceDataColumns }),
        React.createElement(PlateBuyer, { buyerData: buyerData, buyerTitle: buyerTitle }),
        isVirtualized === true ?
            React.createElement(PlateGoodsVirtualized, { goodsColumns: goodsColumns, goodsData: goodsData, totalNum: totalNum, totalNumText: totalNumText, goodsOption: goodsOption }) :
            React.createElement(PlateGoods, { goodsColumns: goodsColumns, goodsData: goodsData, totalNum: totalNum, totalNumText: totalNumText, goodsOption: goodsOption }),
        React.createElement(PlateSeller, { sellerData: sellerData, sellerTitle: sellerTitle }),
        React.createElement(PlatePerson, { personData: personData }),
        otherElement));
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/kts-invoice-plate/InvoicePlate/index.js
// module id = 4187
// module chunks = 0